import styled, { css } from 'styled-components';
import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { LoginModalStyles } from '../LoginModal/LoginModal.styles';
import { cubicEaseOut } from '@helpers/animation';
import { Device, from, until } from '@helpers/media';
const Container = styled.div `
  min-height: calc(100dvh - 185px); // Header, need to add breakpoints //
  position: relative;
  display: flex;
  flex-direction: column;

  ${() => LoginModalStyles.ForgottenPassword} {
    user-select: none;
  }

  ${({ showSignupForm }) => showSignupForm &&
    css `
      div[data-form='login'],
      div[data-form='signup-cta'] {
        ${() => FormWrapper} {
          opacity: 0;
          transform: translateY(25px);
        }
      }

      div[data-form='signup-cta'] {
        ${() => FormContainer} {
          background-color: ${brand.grey.grey89};
        }
      }
    `};
`;
const FormContainer = styled.div `
  display: flex;
  justify-content: center;
  padding: 100px 0px;
  height: 100%;

  transition: background-color 0.2s ease-in-out;
`;
const FormWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: max-content;
  max-height: 100%;

  transition: opacity 0.5s ease-in-out, transform 0.5s ${cubicEaseOut};
`;
const FormContent = styled.div `
  width: 100%;
  max-width: 80%;
  ${LoginModalStyles.Input}::placeholder {
    opacity: 0.5;
  }
`;
const FormTitle = styled.h1 `
  ${fonts.DaxPro.Medium};
  font-size: 35px;
  color: ${brand.grey.grey20};
  margin-bottom: 35px;
`;
const LoginAndSignupWrapper = styled.div `
  @media ${until(Device.TabletLarge)} {
    display: flex;
    flex-direction: column;
  }

  @media ${from(Device.TabletLarge)} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    flex-grow: 1;
  }

  width: 100%;
  height: 100%;
  transition: opacity 0.2s ease-in-out;
`;
const SignupFormWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform 0.5s ${cubicEaseOut}, opacity 0.2s ease-in-out;

  ${({ active }) => active
    ? css `
          transform: translateY(0px);
          opacity: 1;
        `
    : css `
          transform: translateY(50px);
          pointer-events: none;
          opacity: 0;
        `};
`;
const Error = styled.span `
  font-size: 15px;
  color: ${brand.red.base};
`;
export const LoginSignupStyles = {
    Container,
    FormContainer,
    FormWrapper,
    FormContent,
    FormTitle,
    LoginAndSignupWrapper,
    SignupFormWrapper,
    Error,
};
